<template>
  <el-drawer
    :visible.sync="internalVisible"
    :with-header="true"
    title="批量去重"
    size="80%"
    class="duplicate-clean-drawer"
  >
    <div class="drawer-body">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="合并商品" name="merge">
          <el-alert
            type="warning"
            show-icon
            :closable="false"
            title="已找到以下重复商品，支持选择商品后合并平台资料，相同平台资料在合并时不覆盖保留商品对应的平台资料"
            class="tips"
          />
          <div class="toolbar">
            <el-button type="primary" @click="openMergeConfirm">批量合并平台资料</el-button>
            <el-select v-model="mergeSelectScope" placeholder="全选范围" size="mini" style="margin-left:12px;width:140px" @change="onMergeSelectScopeChange" clearable>
              <el-option label="单页全选" value="page" />
              <el-option label="全部页选择" value="all" />
            </el-select>
          </div>
          <!-- 空状态：无数据时展示（使用 Table empty-text 保持一致风格） -->
          <el-table
            v-if="!loading && isEmpty"
            :data="[]"
            border
            size="mini"
            stripe
            style="width: 100%"
            empty-text="暂无重复商品数据"
          />
          <div class="list-with-pagination">
            <div class="group-list-scroll">
              <div v-for="group in pagedGroups" :key="group.id" class="group-block">
                <div class="group-header">
                  <span>重复商品{{ (group.items && group.items.length) || 0 }}条</span>
                  <span class="divider">|</span>
                  <span>重复编码：{{ (group.duplicateCodes && group.duplicateCodes.join(', ')) || '-' }}</span>
                  <el-button class="collapse-btn" type="text" @click="toggleGroup(group.id)">{{ isExpanded(group.id) ? '收起' : '展开' }}</el-button>
                </div>
                <el-table
                  :ref="'mergeTable-' + group.id"
                  v-show="isExpanded(group.id)"
                  :data="group.items || []"
                  border
                  size="mini"
                  stripe
                  style="width: 100%;max-height: 400px; overflow: auto"
                  :row-style="{ height: '60px' }"
                  @selection-change="(rows) => onSelectionChange(group.id, rows)"
                  :row-key="getRowKey"
                >
                  <el-table-column type="selection" width="55" />
                  <el-table-column type="index" label="序号" width="60" :index="(i) => i + 1" />
                  <el-table-column label="商品主图">
                    <template slot-scope="scope">
                      <ListLazyImg :src="scope.row.mainImage" :size="imgSize"/>
                    </template>
                  </el-table-column>
                  <el-table-column prop="title" label="商品名称" min-width="180" show-overflow-tooltip />
                  <el-table-column prop="outerId" label="款式编码" min-width="260" show-overflow-tooltip />
                  <el-table-column prop="completedPlatforms" label="已完善资料平台" min-width="240">
                    <template slot-scope="scope">
                      <div class="platform-icon-wrap">
                        <el-tooltip v-for="(p) in showPlatforms(scope.row)" :key="p.key" :content="p.name" placement="top">
                          <img class="mgr3 img-icon" :src="p.icon" alt=""/>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="source" label="商品来源" min-width="120" />
                  <el-table-column prop="creatorTime" label="创建人/创建时间" min-width="140" show-overflow-tooltip />
                </el-table>
              </div>
            </div>
            <div class="pagination">
              <el-pagination
                background
                :current-page="pagination.pageNo"
                :page-size="pagination.pageSize"
                :total="totalGroups"
                :page-sizes="[5,10,20]"
                layout="prev, pager, next, jumper, sizes, total"
                @current-change="onPageChange"
                @size-change="onPageSizeChange"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="删除商品" name="delete">
          <div class="toolbar">
            <el-button type="danger" @click="onDelete">删除商品</el-button>
          </div>
          <div class="quick-delete-bar">
            <!-- 新增 删除Tab 选择范围下拉框与保留规则单选按钮，用于批量选择删除项 -->
            <el-select v-model="deleteSelectScope" placeholder="请选择" size="mini" class="mgr8" style="width:140px" @change="onDeleteSelectScopeChange">
              <el-option label="单页全选" value="page" />
              <el-option label="全部页选择" value="all" />
            </el-select>
            <span class="mgr8">请选择保留规则：</span>
            <el-radio-group v-model="deleteRule" size="mini" class="mgr8" @change="onDeleteRuleChange">
              <el-radio-button label="earliest">保留最早创建商品</el-radio-button>
              <el-radio-button label="latest">保留最晚创建商品</el-radio-button>
              <el-radio-button label="platformMost">保留已完善平台最多的商品</el-radio-button>
            </el-radio-group>
            <el-button type="text" size="mini" @click="onResetDeleteAll">重置选择</el-button>
          </div>
          <!-- 空状态：无数据时展示（使用 Table empty-text 保持一致风格） -->
          <el-table
            v-if="!loading && isEmpty"
            :data="[]"
            border
            size="mini"
            stripe
            style="width: 100%"
            empty-text="暂无重复商品数据"
          />
          <div class="list-with-pagination">
            <div class="group-list-scroll">
              <div v-for="group in pagedGroups" :key="'del-'+group.id" class="group-block">
                <div class="group-header">
                  <span>重复商品{{ (group.items && group.items.length) || 0 }}条</span>
                  <span class="divider">|</span>
                  <span>重复编码：{{ (group.duplicateCodes && group.duplicateCodes.join(', ')) || '-' }}</span>
                  <el-button class="collapse-btn" type="text" @click="toggleGroup(group.id)">{{ isExpanded(group.id) ? '收起' : '展开' }}</el-button>
                </div>
                <el-table
                  :ref="'deleteTable-' + group.id"
                  v-show="isExpanded(group.id)"
                  :data="group.items || []"
                  border
                  size="mini"
                  stripe
                  style="width: 100%"
                  @selection-change="(rows) => onSelectionChange(group.id, rows)"
                  :row-key="getRowKey"
                >
                  <el-table-column type="selection" width="55" />
                  <el-table-column type="index" label="序号" width="60" :index="(i) => i + 1" />
                  <el-table-column label="商品主图" width="90">
                    <template slot-scope="scope">
                      <ListLazyImg :src="scope.row.mainImage" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="title" label="商品名称" min-width="180" show-overflow-tooltip />
                  <el-table-column prop="outerId" label="款式编码" min-width="260" show-overflow-tooltip />
                  <el-table-column prop="completedPlatforms" label="已完善资料平台" min-width="240">
                    <template slot-scope="scope">
                      <div class="platform-icon-wrap">
                        <el-tooltip v-for="(p) in showPlatforms(scope.row)" :key="p.key" :content="p.name" placement="top">
                          <img class="mgr3 img-icon" :src="p.icon" alt=""/>
                        </el-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="source" label="商品来源" min-width="120" />
                  <el-table-column prop="creatorTime" label="创建人/创建时间" min-width="140" show-overflow-tooltip />
                </el-table>
              </div>
            </div>
            <div class="pagination">
              <el-pagination
                background
                :current-page="pagination.pageNo"
                :page-size="pagination.pageSize"
                :total="totalGroups"
                :page-sizes="[5,10,20]"
                layout="prev, pager, next, jumper, sizes, total"
                @current-change="onPageChange"
                @size-change="onPageSizeChange"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 二次确认合并弹窗 -->
    <el-dialog title="确认合并" :visible.sync="mergeConfirm.visible" width="520px">
      <div class="merge-confirm-text">
        确认将平台资料合并到已完善平台资料最多的商品中？
        <br />
        合并：合并完成后不删除被合并的商品
        <br />
        合并并删除：合并完成后删除被合并的商品
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mergeConfirm.visible = false">取 消</el-button>
        <el-button type="primary" @click="emitMerge">合 并</el-button>
        <el-button type="danger" @click="emitMergeAndDelete">合并并删除</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="合并进度"
      :visible.sync="mergeProgress.visible"
      width="520px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="merge-progress-wrap">
        <div class="merge-progress-row">
          <span class="merge-progress-label">进度：</span>
          <span>{{ mergeProgress.done }}/{{ mergeProgress.total }}</span>
        </div>
        <div class="merge-progress-row">
          <span class="merge-progress-label">成功：</span>
          <span>{{ mergeProgress.success }}</span>
          <span class="merge-progress-split">|</span>
          <span class="merge-progress-label">失败：</span>
          <span>{{ mergeProgress.fail }}</span>
        </div>
        <el-progress :percentage="mergeProgressPercent" :status="mergeProgressStatus" />
        <div v-if="mergeProgress.retry.total > 0" class="merge-progress-retry">
          <div class="merge-progress-row">
            <span class="merge-progress-label">重试进度：</span>
            <span>{{ mergeProgress.retry.done }}/{{ mergeProgress.retry.total }}</span>
          </div>
          <div class="merge-progress-row">
            <span class="merge-progress-label">重试成功：</span>
            <span>{{ mergeProgress.retry.success }}</span>
            <span class="merge-progress-split">|</span>
            <span class="merge-progress-label">重试失败：</span>
            <span>{{ mergeProgress.retry.fail }}</span>
          </div>
          <el-progress :percentage="mergeRetryPercent" :status="mergeRetryStatus" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="!mergeProgress.running && !mergeProgress.retry.running && mergeProgress.failedTasks.length > 0"
          type="primary"
          @click="retryMergeFailed"
        >失败重试（{{ mergeProgress.failedTasks.length }}）</el-button>
        <el-button :disabled="mergeProgress.running || mergeProgress.retry.running" @click="closeMergeProgressDialog">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="删除进度"
      :visible.sync="deleteProgress.visible"
      width="520px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="merge-progress-wrap">
        <!-- 获取数据进度 -->
        <div v-if="deleteProgress.fetchStatus === 'fetching'" class="fetching-progress">
          <div class="merge-progress-row">
            <span class="merge-progress-label">正在获取数据：</span>
            <span>{{ deleteProgress.fetchCurrent }}/{{ deleteProgress.fetchTotal }}</span>
          </div>
          <el-progress :percentage="fetchProgressPercent" />
        </div>

        <!-- 处理数据进度 -->
        <div v-if="deleteProgress.processStatus === 'processing'" class="processing-progress">
          <div class="merge-progress-row">
            <span class="merge-progress-label">正在处理数据：</span>
            <span>{{ deleteProgress.processCurrent }}/{{ allGroupsLength || 0 }}</span>
          </div>
          <el-progress :percentage="processProgressPercent" />
        </div>

        <!-- 等待确认 -->
        <div v-if="deleteProgress.waitingConfirm" class="waiting-confirm">
          <div class="merge-progress-row">
            <span>已准备好删除数据</span>
          </div>
          <div class="merge-progress-row confirm-info">
            <span>共 <strong>{{ toDeleteBaseItemIds.length }}</strong> 条数据待删除</span>
          </div>
          <div class="confirm-tips">
            <el-alert
              title="请确认是否删除上述数据"
              type="warning"
              :closable="false"
              show-icon
            />
          </div>
        </div>

        <!-- 删除进度 -->
        <div v-if="deleteProgress.status === 'deleting'" class="deleting-progress">
          <div class="merge-progress-row">
            <span class="merge-progress-label">进度：</span>
            <span>{{ deleteProgress.done }}/{{ deleteProgress.total }}</span>
          </div>
          <div class="merge-progress-row">
            <span class="merge-progress-label">成功：</span>
            <span>{{ deleteProgress.success }}</span>
            <span class="merge-progress-split">|</span>
            <span class="merge-progress-label">失败：</span>
            <span>{{ deleteProgress.fail }}</span>
          </div>
          <el-progress :percentage="deleteProgressPercent" :status="deleteProgressStatus" />
        </div>

        <!-- 默认进度（已完成） -->
        <div v-if="deleteProgress.status !== 'deleting' && deleteProgress.fetchStatus !== 'fetching' && deleteProgress.processStatus !== 'processing' && !deleteProgress.waitingConfirm" class="merge-progress-wrap">
          <div class="merge-progress-row">
            <span class="merge-progress-label">进度：</span>
            <span>{{ deleteProgress.done }}/{{ deleteProgress.total }}</span>
          </div>
          <div class="merge-progress-row">
            <span class="merge-progress-label">成功：</span>
            <span>{{ deleteProgress.success }}</span>
            <span class="merge-progress-split">|</span>
            <span class="merge-progress-label">失败：</span>
            <span>{{ deleteProgress.fail }}</span>
          </div>
          <el-progress :percentage="deleteProgressPercent" :status="deleteProgressStatus" />
        </div>

        <div v-if="deleteProgress.retry.total > 0" class="merge-progress-retry">
          <div class="merge-progress-row">
            <span class="merge-progress-label">重试进度：</span>
            <span>{{ deleteProgress.retry.done }}/{{ deleteProgress.retry.total }}</span>
          </div>
          <div class="merge-progress-row">
            <span class="merge-progress-label">重试成功：</span>
            <span>{{ deleteProgress.retry.success }}</span>
            <span class="merge-progress-split">|</span>
            <span class="merge-progress-label">重试失败：</span>
            <span>{{ deleteProgress.retry.fail }}</span>
          </div>
          <el-progress :percentage="deleteRetryPercent" :status="deleteRetryStatus" />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 等待确认时的按钮 -->
        <el-button
          v-if="deleteProgress.waitingConfirm"
          type="default"
          @click="cancelDelete"
        >取消</el-button>
        <el-button
          v-if="deleteProgress.waitingConfirm"
          type="primary"
          :disabled="!toDeleteBaseItemIds.length"
          @click="confirmDelete"
        >确认删除（{{ toDeleteBaseItemIds.length }}条）</el-button>

        <!-- 失败重试按钮 -->
        <el-button
          v-if="!deleteProgress.running && !deleteProgress.retry.running && !deleteProgress.waitingConfirm && deleteProgress.failedTasks.length > 0"
          type="primary"
          @click="retryDeleteFailed"
        >失败重试（{{ deleteProgress.failedTasks.length }}）</el-button>
        <el-button
          :disabled="deleteProgress.running || deleteProgress.retry.running"
          @click="closeDeleteProgressDialog"
        >关闭</el-button>
      </span>
    </el-dialog>
  </el-drawer>
</template>

<script>
import ListLazyImg from '@/components/ListLazyImg/index.vue';
import { PLATFORM_KEYS_4_COLS, PLATFORMS } from '@/dictionary/platforms.js';
import { getDuplicateGroupList, mergeRepeatItems, deleteRepeatItems, getRepeatItemIdsList } from '@/servers/prod/center/index.js';

export default {
  name: 'DuplicateCleanDrawer',
  components: { ListLazyImg },
  props: {
    visible: { type: Boolean, default: false },
    groups: { type: Array, default: () => [] },
    defaultTab: { type: String, default: 'merge' },
    // 远程查询参数（可选）：若传入则打开抽屉时按此参数拉取服务端列表
    queryParams: { type: Object, default: () => ({}) },
    // 是否在抽屉打开时自动拉取远程列表
    fetchOnOpen: { type: Boolean, default: true },
  },
  data() {
    return {
      internalVisible: this.visible,
      activeTab: this.defaultTab,
      selections: {},
      mergeConfirm: { visible: false },
      mergeProgress: {
        visible: false,
        total: 0,
        done: 0,
        success: 0,
        fail: 0,
        running: false,
        failedTasks: [],
        retry: {
          total: 0,
          done: 0,
          success: 0,
          fail: 0,
          running: false,
        },
      },
      deleteProgress: {
        visible: false,
        total: 0,
        done: 0,
        success: 0,
        fail: 0,
        running: false,
        failedTasks: [],
        retry: {
          total: 0,
          done: 0,
          success: 0,
          fail: 0,
          running: false,
        },
        // 获取数据进度
        fetchStatus: '', // 'fetching'
        fetchCurrent: 0,
        fetchTotal: 0,
        // 处理数据进度
        processStatus: '', // 'processing'
        processCurrent: 0,
        // 等待确认状态
        waitingConfirm: false, // 是否等待用户确认
      },
      allGroupsLength: 0, // 获取到的总组数（用于处理进度显示）
      toDeleteBaseItemIds: [], // 待删除的 baseItemIds 列表
      mergeSelectAllPage: false, // 兼容旧逻辑（保留）
      mergeSelectScope: '', // 下拉选择：'page' | 'all'
      deleteSelectScope: 'page', // 新增 删除Tab范围：'page' | 'all'
      deleteRule: '', // 新增 删除Tab保留规则：'earliest' | 'latest' | 'platformMost'
      loading: false,
      apiError: null,
      remote: { groups: [], total: 0 },
      pagination: { pageNo: 1, pageSize: 5 },
      expandState: {},
    };
  },
  computed: {
    // 实际展示的数据：仅使用服务端接口返回的分组
    displayGroups() {
      return this.remote.groups || [];
    },
    // 是否为空：无分组或所有分组均无条目
    isEmpty() {
      const gps = this.displayGroups || [];
      if (!gps.length) return true;
      return gps.every(g => !(g.items && g.items.length));
    },
    pagedGroups() {
      // 接口已按分页返回，直接使用当前页数据
      return this.displayGroups;
    },
    totalGroups() {
      return Number(this.remote.total || 0);
    },
    imgSize() {
      return {
        width: 45,
        height: 45,
      }
    },
    mergeProgressPercent() {
      const total = Number(this.mergeProgress.total || 0);
      const done = Number(this.mergeProgress.done || 0);
      if (!total) return 0;
      const pct = Math.floor((done / total) * 100);
      return Math.max(0, Math.min(100, pct));
    },
    mergeProgressStatus() {
      if (this.mergeProgress.running) return undefined;
      if (!this.mergeProgress.total) return 'success';
      if (this.mergeProgress.done >= this.mergeProgress.total && this.mergeProgress.fail === 0) return 'success';
      if (this.mergeProgress.done >= this.mergeProgress.total && this.mergeProgress.fail > 0) return 'exception';
      return undefined;
    },
    mergeRetryPercent() {
      const total = Number(this.mergeProgress.retry.total || 0);
      const done = Number(this.mergeProgress.retry.done || 0);
      if (!total) return 0;
      const pct = Math.floor((done / total) * 100);
      return Math.max(0, Math.min(100, pct));
    },
    mergeRetryStatus() {
      if (this.mergeProgress.retry.running) return undefined;
      if (!this.mergeProgress.retry.total) return undefined;
      if (this.mergeProgress.retry.done >= this.mergeProgress.retry.total && this.mergeProgress.retry.fail === 0) return 'success';
      if (this.mergeProgress.retry.done >= this.mergeProgress.retry.total && this.mergeProgress.retry.fail > 0) return 'exception';
      return undefined;
    },
    deleteProgressPercent() {
      const total = Number(this.deleteProgress.total || 0);
      const done = Number(this.deleteProgress.done || 0);
      if (!total) return 0;
      const pct = Math.floor((done / total) * 100);
      return Math.max(0, Math.min(100, pct));
    },
    deleteProgressStatus() {
      // 正在删除中
      if (this.deleteProgress.status === 'deleting' && this.deleteProgress.done < this.deleteProgress.total) return undefined;
      if (!this.deleteProgress.total) return 'success';
      if (this.deleteProgress.done >= this.deleteProgress.total && this.deleteProgress.fail === 0) return 'success';
      if (this.deleteProgress.done >= this.deleteProgress.total && this.deleteProgress.fail > 0) return 'exception';
      return undefined;
    },
    deleteRetryPercent() {
      const total = Number(this.deleteProgress.retry.total || 0);
      const done = Number(this.deleteProgress.retry.done || 0);
      if (!total) return 0;
      const pct = Math.floor((done / total) * 100);
      return Math.max(0, Math.min(100, pct));
    },
    deleteRetryStatus() {
      if (this.deleteProgress.retry.running) return undefined;
      if (!this.deleteProgress.retry.total) return undefined;
      if (this.deleteProgress.retry.done >= this.deleteProgress.retry.total && this.deleteProgress.retry.fail === 0) return 'success';
      if (this.deleteProgress.retry.done >= this.deleteProgress.retry.total && this.deleteProgress.retry.fail > 0) return 'exception';
      return undefined;
    },
    // 获取数据进度百分比
    fetchProgressPercent() {
      const total = Number(this.deleteProgress.fetchTotal || 0);
      const current = Number(this.deleteProgress.fetchCurrent || 0);
      if (!total) return 0;
      const pct = Math.floor((current / total) * 100);
      return Math.max(0, Math.min(100, pct));
    },
    // 处理数据进度百分比
    processProgressPercent() {
      const total = this.allGroupsLength || 0;
      const current = Number(this.deleteProgress.processCurrent || 0);
      if (!total) return 0;
      const pct = Math.floor((current / total) * 100);
      return Math.max(0, Math.min(100, pct));
    },
  },
  watch: {
    visible(val) { this.internalVisible = val; },
    internalVisible(val) {
      this.$emit('update:visible', val);
      if (val && this.fetchOnOpen) {
        this.fetchGroups();
      } else if (!val) {
        // 关闭抽屉时，清空全选范围的分页数据
        const isMergeAll = this.mergeSelectScope === 'all';
        const isDeleteAll = this.deleteSelectScope === 'all';
        if (isMergeAll || isDeleteAll) {
          // 如果是全部页选择，清空对应的全选范围
          if (isMergeAll) {
            this.mergeSelectScope = '';
          }
          if (isDeleteAll) {
            this.deleteSelectScope = 'page';
            this.deleteRule = '';
          }
        }
        // 重置分页
        this.pagination.pageNo = 1;
      }
    },
  },
  methods: {
    /**
     * 关闭合并进度弹窗：关闭后清空“全选范围”下拉选项，避免残留为“全部页选择”
     */
    closeMergeProgressDialog() {
      this.mergeProgress.visible = false;
      this.mergeSelectScope = '';
    },
    /**
     * 关闭删除进度弹窗：关闭后清空“保留规则”，避免残留导致下次误用
     */
    closeDeleteProgressDialog() {
      this.deleteProgress.visible = false;
      this.deleteRule = '';
    },
    async fetchGroups() {
      this.loading = true;
      this.apiError = null;
      try {
        const qp = this.queryParams || {};
        const params = {
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
          startTime: qp.startTime,
          endTime: qp.endTime,
        };
        const data = await getDuplicateGroupList(params);
        const records = Array.isArray(data && data.records) ? data.records : [];
        const total = Number((data && data.total) || 0);
        const groups = records.map((rec, idx) => {
          const details = Array.isArray(rec.itemDetails) ? rec.itemDetails : [];
          return {
            id: rec.repeatId || `repeat-${idx + 1}`,
            duplicateCodes: details.map(it => it.outerId || ''),
            items: details.map(it => {
              let platformCodes = [];
              const cps = it.canPublishPlatforms;
              if (Array.isArray(cps)) {
                cps.forEach(p => {
                  if (typeof p === 'string') {
                    try {
                      const parsed = JSON.parse(p);
                      if (Array.isArray(parsed)) {
                        parsed.forEach(code => { if (typeof code === 'string') platformCodes.push(code); });
                      } else {
                        platformCodes.push(p);
                      }
                    } catch (e) {
                      platformCodes.push(p);
                    }
                  } else if (Array.isArray(p)) {
                    p.forEach(code => { if (typeof code === 'string') platformCodes.push(code); });
                  }
                });
              }
              platformCodes = Array.from(new Set(platformCodes.filter(Boolean)));
              const canPublishPlatform = platformCodes.length > 0 ? JSON.stringify(platformCodes) : '[]';
              return {
                mainImage: it.mainImage || '',
                title: it.title || '',
                outerId: it.outerId || '',
                completedPlatforms: platformCodes,
                canPublishPlatform,
                source: it.itemSource || '',
                creatorTime: `${it.createByName || '无'}${it.createTime ? (' / ' + it.createTime) : ''}`.trim(),
                baseItemId: it.baseItemId || ''
              };
            })
          };
        });
        this.remote.groups = groups;
        this.remote.total = total;
        const expand = {};
        (this.remote.groups || []).forEach(g => { expand[g.id] = true; });
        this.expandState = expand;
      } catch (e) {
        this.apiError = e;
        this.$message && this.$message.error('重复商品列表加载失败');
      } finally {
        this.loading = false;
      }
    },
    onSelectionChange(groupId, rows) {
      this.$set(this.selections, groupId, rows);
    },
    /**
     * 分页：页码变化
     * - 保持原有分页查询逻辑（不因“全部页选择”而放大 pageSize 额外查询）
     * - 当选择范围为“全部页选择”时：翻页后自动对当前页数据进行勾选呈现/快捷规则选择
     *
     * @param {number} page 目标页码
     */
    async onPageChange(page) {
      this.pagination.pageNo = page;
      // 若为远程数据，分页变更时刷新列表
      if (this.fetchOnOpen) await this.fetchGroups();
      this.mergeSelectAllPage = false;

      // 如果选择的是全部页选择，则不清空数据，并重新应用选中；否则清空
      const isMergeAll = this.mergeSelectScope === 'all';
      const isDeleteAll = this.deleteSelectScope === 'all';

      if (isMergeAll) {
        // 合并 Tab 全部页选择：分页后重新全选当前页
        this.applyMergeSelectAllPage();
      } else if (!isMergeAll) {
        this.mergeSelectScope = '';
      }

      if (isDeleteAll) {
        // 删除 Tab 全部页选择：分页后重新应用保留规则
        if (this.deleteRule) {
          this.applyQuickDeleteAll(this.deleteRule);
        }
      } else if (!isDeleteAll) {
        this.deleteSelectScope = 'page';
        this.deleteRule = '';
      }

      if (!isMergeAll && !isDeleteAll) {
        this.clearAllSelections();
      }
    },
    /**
     * 分页：每页条数变化
     * - 保持原有分页查询逻辑（不因“全部页选择”而放大 pageSize 额外查询）
     * - 当选择范围为“全部页选择”时：变更后自动对当前页数据进行勾选呈现/快捷规则选择
     *
     * @param {number} size 每页条数
     */
    async onPageSizeChange(size) {
      this.pagination.pageSize = size;
      this.pagination.pageNo = 1;
      // 若为远程数据，分页变更时刷新列表
      if (this.fetchOnOpen) await this.fetchGroups();
      this.mergeSelectAllPage = false;

      // 如果选择的是全部页选择，则不清空数据，并重新应用选中；否则清空
      const isMergeAll = this.mergeSelectScope === 'all';
      const isDeleteAll = this.deleteSelectScope === 'all';

      if (isMergeAll) {
        // 合并 Tab 全部页选择：变更后重新全选当前页
        this.applyMergeSelectAllPage();
      } else if (!isMergeAll) {
        this.mergeSelectScope = '';
      }

      if (isDeleteAll) {
        // 删除 Tab 全部页选择：变更后重新应用保留规则
        if (this.deleteRule) {
          this.applyQuickDeleteAll(this.deleteRule);
        }
      } else if (!isDeleteAll) {
        this.deleteSelectScope = 'page';
        this.deleteRule = '';
      }

      if (!isMergeAll && !isDeleteAll) {
        this.clearAllSelections();
      }
    },
    /**
     * 清空所有分组表格的选中状态（合并 Tab 和删除 Tab）
     */
    clearAllSelections() {
      this.$nextTick(() => {
        this.pagedGroups.forEach(group => {
          // 清空合并表格选中
          const mergeRef = this.$refs['mergeTable-' + group.id];
          const mergeTables = Array.isArray(mergeRef) ? mergeRef : (mergeRef ? [mergeRef] : []);
          mergeTables.forEach(t => {
            try { if (typeof t.clearSelection === 'function') t.clearSelection(); } catch (e) {}
          });

          // 清空删除表格选中
          const deleteRef = this.$refs['deleteTable-' + group.id];
          const deleteTables = Array.isArray(deleteRef) ? deleteRef : (deleteRef ? [deleteRef] : []);
          deleteTables.forEach(t => {
            try { if (typeof t.clearSelection === 'function') t.clearSelection(); } catch (e) {}
          });

          // 清空数据层选中状态
          this.$set(this.selections, group.id, []);
        });
      });
    },
    getRowKey(row) {
      // 优先使用后端返回的 baseItemId 作为稳定行键
      return row.baseItemId || ((row.outerId || '') + '_' + (row.title || ''));
    },
    isExpanded(groupId) {
      return this.expandState[groupId] !== false;
    },
    toggleGroup(groupId) {
      const next = !this.isExpanded(groupId);
      this.$set(this.expandState, groupId, next);
    },
    showPlatforms(row) {
      if (!row.canPublishPlatform) return [];
      const curPlatforms = [];
      PLATFORM_KEYS_4_COLS.forEach((key) => {
        if (row.canPublishPlatform.includes(key)) {
          curPlatforms.push(PLATFORMS[key]);
        }
      });
      return curPlatforms;
    },
    // 合并前校验：每个重复分组如有选择，需至少选择两项
    validateMergeSelections() {
      const groups = this.displayGroups || [];
      let hasAnySelection = false;
      const invalidGroupIds = [];
      groups.forEach(group => {
        const selected = this.selections[group.id] || [];
        if (selected.length > 0) hasAnySelection = true;
        if (selected.length === 1) invalidGroupIds.push(group.id);
      });
      if (!hasAnySelection) {
        this.$message && this.$message.warning('请在重复商品分组中选择要合并的商品（至少两项）');
        return false;
      }
      if (invalidGroupIds.length) {
        this.$message && this.$message.warning('存在重复编码分组仅选择1项，请至少选择2项再进行合并');
        // 帮助用户定位问题分组：展开这些分组
        invalidGroupIds.forEach(id => this.$set(this.expandState, id, true));
        return false;
      }
      return true;
    },
    onToggleMergeSelectAllPage(val) {
      // 仅对当前分页的组进行全选/全不选
      this.$nextTick(() => {
        this.pagedGroups.forEach(group => {
          const ref = this.$refs['mergeTable-' + group.id];
          const tables = Array.isArray(ref) ? ref : (ref ? [ref] : []);
          if (!tables.length) return;
          tables.forEach(t => {
            try {
              if (typeof t.clearSelection === 'function') {
                t.clearSelection();
              }
              if (val) {
                if (typeof t.toggleAllSelection === 'function') {
                  t.toggleAllSelection();
                } else if (typeof t.toggleRowSelection === 'function') {
                  (group.items || []).forEach(row => t.toggleRowSelection(row, true));
                }
              }
            } catch (e) { /* noop */ }
          });
          if (!val) {
            // 取消单页全选时，清空当页选择缓存
            this.$set(this.selections, group.id, []);
          }
        });
      });
    },
    /**
     * 合并Tab：下拉选择范围变化时触发
     * - “单页全选”：仅对当前页数据全选
     * - “全部页选择”：不额外请求全部数据，仍按分页查询；翻页时自动对当前页全选
     *
     * @param {string} val 选择范围：'page' | 'all'
     */
    onMergeSelectScopeChange(val) {
      if (!val) {
        // 清空时，清除当前页选中状态
        this.clearMergeSelectionsOnPage();
      } else if (val === 'page') {
        // 单页全选
        this.applyMergeSelectAllPage();
      } else if (val === 'all') {
        // 全部页选择
        this.applyMergeSelectAllPage();
      }
    },
    // 合并Tab：当前页全选
    applyMergeSelectAllPage() {
      this.$nextTick(() => {
        this.pagedGroups.forEach(group => {
          const ref = this.$refs['mergeTable-' + group.id];
          const tables = Array.isArray(ref) ? ref : (ref ? [ref] : []);
          tables.forEach(t => {
            try {
              if (typeof t.clearSelection === 'function') t.clearSelection();
              if (typeof t.toggleAllSelection === 'function') {
                t.toggleAllSelection();
              } else if (typeof t.toggleRowSelection === 'function') {
                (group.items || []).forEach(row => t.toggleRowSelection(row, true));
              }
            } catch (e) {}
          });
          this.$set(this.selections, group.id, (group.items || []).slice());
        });
      });
    },
    // 合并Tab：全部页选择（数据层面为所有分组全选，界面上对当前页进行勾选呈现）
    applyMergeSelectAllAll() {
      // 数据层面：所有分组均设置为全选
      (this.displayGroups || []).forEach(group => {
        this.$set(this.selections, group.id, (group.items || []).slice());
      });
      // 当前页：表格呈现勾选状态
      this.applyMergeSelectAllPage();
    },
    // 清空当前页选择（用于下拉清空或切换）
    clearMergeSelectionsOnPage() {
      this.$nextTick(() => {
        this.pagedGroups.forEach(group => {
          const ref = this.$refs['mergeTable-' + group.id];
          const tables = Array.isArray(ref) ? ref : (ref ? [ref] : []);
          tables.forEach(t => {
            try { if (typeof t.clearSelection === 'function') t.clearSelection(); } catch (e) {}
          });
          this.$set(this.selections, group.id, []);
        });
      });
    },
    openMergeConfirm() {
      if (this.mergeSelectScope !== 'all' && !this.validateMergeSelections()) return;
      this.mergeConfirm.visible = true;
    },
    async emitMerge() {
      this.mergeConfirm.visible = false;
      if (this.mergeSelectScope === 'all') {
        await this.doMergeAllByPaging();
        return;
      }
      if (!this.validateMergeSelections()) return;
      await this.doMerge();
    },
    async emitMergeAndDelete() {
      this.mergeConfirm.visible = false;
      if (this.mergeSelectScope === 'all') {
        await this.doMergeAllByPaging(true);
        return;
      }
      if (!this.validateMergeSelections()) return;
      await this.doMerge(true);
    },
    /**
     * 全部页选择：调用新接口获取所有重复记录 ID 和 baseItemIds，分批次执行合并，过程展示进度弹窗
     * - 仅在 mergeSelectScope === 'all' 时使用
     *
     * @param {boolean} alsoDelete 是否合并并删除
     */
    async doMergeAllByPaging(alsoDelete = false) {
      const mergeType = alsoDelete ? 'merge_and_delete' : 'merge';
      const qp = this.queryParams || {};
      const BATCH_SIZE = 10; // 每批次处理 10 条
      const resetProgress = () => {
        this.mergeProgress.total = 0;
        this.mergeProgress.done = 0;
        this.mergeProgress.success = 0;
        this.mergeProgress.fail = 0;
        this.mergeProgress.failedTasks = [];
        this.mergeProgress.retry.total = 0;
        this.mergeProgress.retry.done = 0;
        this.mergeProgress.retry.success = 0;
        this.mergeProgress.retry.fail = 0;
        this.mergeProgress.retry.running = false;
      };
      const runOneRecord = async (rec) => {
        const repeatId = (rec && rec.id) ? String(rec.id) : '';
        const baseItemIds = Array.isArray(rec && rec.baseItemIds) ? rec.baseItemIds.map(id => String(id)) : [];
        if (!repeatId || baseItemIds.length < 2) {
          this.mergeProgress.done += 1;
          return { ok: true };
        }
        const ok = await mergeRepeatItems({ repeatId, baseItemIds, mergeType });
        if (ok) this.mergeProgress.success += 1;
        else {
          this.mergeProgress.fail += 1;
          this.mergeProgress.failedTasks.push({ repeatId, baseItemIds, mergeType });
        }
        this.mergeProgress.done += 1;
        return { ok: !!ok };
      };
      const runBatchWithConcurrency = async (batch) => {
        const list = Array.isArray(batch) ? batch : [];
        if (!list.length) return { allOk: true };
        let allOk = true;
        const results = await Promise.all(list.map(async (rec) => {
          try {
            const res = await runOneRecord(rec);
            if (!res || res.ok !== true) allOk = false;
          } catch (e) {
            allOk = false;
            this.mergeProgress.fail += 1;
            this.mergeProgress.done += 1;
            const repeatId = (rec && rec.id) ? String(rec.id) : '';
            const baseItemIds = Array.isArray(rec && rec.baseItemIds) ? rec.baseItemIds.map(id => String(id)) : [];
            if (repeatId && Array.isArray(baseItemIds) && baseItemIds.length >= 2) {
              this.mergeProgress.failedTasks.push({ repeatId, baseItemIds, mergeType });
            }
          }
        }));
        return { allOk };
      };

      resetProgress();
      this.mergeProgress.visible = true;
      this.mergeProgress.running = true;
      this.loading = true;
      try {
        // 调用新接口获取所有重复记录的 ID 和 baseItemIds
        const allRecords = await getRepeatItemIdsList({ startTime: qp.startTime, endTime: qp.endTime });
        const total = Array.isArray(allRecords) ? allRecords.length : 0;
        this.mergeProgress.total = total;
        if (!total) {
          this.$message && this.$message.warning('暂无可合并的重复分组');
          return;
        }

        // 分批次处理（每 10 条为一批）
        for (let i = 0; i < allRecords.length; i += BATCH_SIZE) {
          const batch = allRecords.slice(i, i + BATCH_SIZE);
          await runBatchWithConcurrency(batch);
        }

        await this.fetchGroups();
        // 更新平台额度数据
        this.$store.dispatch('fetchPlatformQuota', { force: true });
        this.selections = {};
        if (this.mergeProgress.fail > 0) {
          this.$message && this.$message.warning(`合并执行完成：成功 ${this.mergeProgress.success} 组，失败 ${this.mergeProgress.fail} 组`);
        } else {
          this.$message && this.$message.success(`合并执行完成：成功 ${this.mergeProgress.success} 组`);
        }
      } catch (e) {
        this.$message && this.$message.error('合并执行异常');
      } finally {
        this.loading = false;
        this.mergeProgress.running = false;
      }
    },
    /**
     * 失败重试：对 doMergeAllByPaging 过程中记录的失败参数再次执行合并
     * - 仅在进度弹窗结束后可点击
     * - 重试成功：从失败列表中移除，并同步更新主统计（success++ / fail--）
     */
    async retryMergeFailed() {
      const tasks = Array.isArray(this.mergeProgress.failedTasks) ? this.mergeProgress.failedTasks.slice() : [];
      if (!tasks.length) return;
      if (this.mergeProgress.running || this.mergeProgress.retry.running) return;

      this.mergeProgress.retry.total = tasks.length;
      this.mergeProgress.retry.done = 0;
      this.mergeProgress.retry.success = 0;
      this.mergeProgress.retry.fail = 0;
      this.mergeProgress.retry.running = true;
      this.loading = true;
      try {
        const concurrency = Math.max(1, Math.min(20, tasks.length));
        let idx = 0;
        const keepFailed = [];
        const workers = new Array(concurrency).fill(0).map(async () => {
          while (idx < tasks.length) {
            const cur = tasks[idx];
            idx += 1;
            const repeatId = cur && cur.repeatId ? String(cur.repeatId) : '';
            const baseItemIds = Array.isArray(cur && cur.baseItemIds) ? cur.baseItemIds.map(id => String(id)) : [];
            const mergeType = cur && cur.mergeType ? String(cur.mergeType) : 'merge';
            if (!repeatId || baseItemIds.length < 2) {
              this.mergeProgress.retry.done += 1;
              this.mergeProgress.retry.success += 1;
              continue;
            }
            try {
              const ok = await mergeRepeatItems({ repeatId, baseItemIds, mergeType });
              if (ok) {
                this.mergeProgress.retry.success += 1;
                this.mergeProgress.success += 1;
                if (this.mergeProgress.fail > 0) this.mergeProgress.fail -= 1;
              } else {
                this.mergeProgress.retry.fail += 1;
                keepFailed.push({ repeatId, baseItemIds, mergeType });
              }
            } catch (e) {
              this.mergeProgress.retry.fail += 1;
              keepFailed.push({ repeatId, baseItemIds, mergeType });
            } finally {
              this.mergeProgress.retry.done += 1;
            }
          }
        });
        await Promise.all(workers);
        this.mergeProgress.failedTasks = keepFailed;
        await this.fetchGroups();
        // 更新平台额度数据
        this.$store.dispatch('fetchPlatformQuota', { force: true });
        if (this.mergeProgress.failedTasks.length > 0) {
          this.$message && this.$message.warning(`重试完成：成功 ${this.mergeProgress.retry.success} 组，失败 ${this.mergeProgress.retry.fail} 组`);
        } else {
          this.$message && this.$message.success(`重试完成：成功 ${this.mergeProgress.retry.success} 组`);
        }
      } catch (e) {
        this.$message && this.$message.error('重试执行异常');
      } finally {
        this.loading = false;
        this.mergeProgress.retry.running = false;
      }
    },
    async doMerge(alsoDelete = false) {
      try {
        this.loading = true;
        // 构造每个分组的合并任务（仅对已选择且>=2项的分组执行合并）
        const tasks = [];
        // 合并类型：
        // - alsoDelete=false -> 仅合并平台资料：merge
        // - alsoDelete=true  -> 合并且删除多余商品：merge_and_delete
        const mergeType = alsoDelete ? 'merge_and_delete' : 'merge';
        const groups = this.displayGroups || [];
        groups.forEach(group => {
          const sel = this.selections[group.id] || [];
          const ids = sel.map(r => r.baseItemId).filter(Boolean).map(id => String(id));
          if (ids.length >= 2) {
            tasks.push(mergeRepeatItems({ repeatId: group.id, baseItemIds: ids, mergeType }));
          }
        });
        if (!tasks.length) {
          this.$message && this.$message.warning('没有可合并的分组（请至少选择两项）');
          return;
        }
        const results = await Promise.all(tasks);
        const okCount = results.filter(Boolean).length;
        const failCount = tasks.length - okCount;
        if (okCount > 0) {
          this.$message && this.$message.success(`合并完成：成功 ${okCount} 组${failCount ? `，失败 ${failCount} 组` : ''}`);
        } else {
          this.$message && this.$message.error('合并失败，请稍后重试');
        }
        // 合并后刷新列表数据
        this.pagination.pageNo = 1;
        await this.fetchGroups();
        this.$store.dispatch('fetchPlatformQuota', { force: true });
        // 清空选择状态
        this.selections = {};
      } catch (e) {
        this.$message && this.$message.error('合并接口调用异常');
      } finally {
        this.loading = false;
      }
    },
    getDeleteBaseItemIds() {
      const groups = this.displayGroups || [];
      const ids = [];
      groups.forEach(group => {
        const selected = this.selections[group.id] || [];
        selected.forEach(row => {
          if (row && row.baseItemId) ids.push(String(row.baseItemId));
        });
      });
      return Array.from(new Set(ids));
    },
    validateDeleteSelections() {
      const ids = this.getDeleteBaseItemIds();
      if (!ids.length) {
        this.$message && this.$message.warning('请选择要删除的商品');
        return false;
      }
      return true;
    },
    async doDelete() {
      try {
        this.loading = true;
        const baseItemIds = this.getDeleteBaseItemIds();
        const ok = await deleteRepeatItems(baseItemIds);
        if (!ok) {
          this.$message && this.$message.error('删除失败，请稍后重试');
          return;
        }
        this.$message && this.$message.success('删除成功');
        this.pagination.pageNo = 1;
        await this.fetchGroups();
        // 更新平台额度数据
        this.$store.dispatch('fetchPlatformQuota', { force: true });
        this.selections = {};
        this.deleteRule = '';
      } catch (e) {
        this.$message && this.$message.error('删除接口调用异常');
      } finally {
        this.loading = false;
      }
    },
    onDelete() {
      if (this.deleteSelectScope === 'all') {
        if (!this.deleteRule) {
          this.$message && this.$message.warning('请选择保留规则');
          return;
        }
        this.$confirm('确认按当前保留规则删除全部页的重复商品？此操作不可撤销。', '提示', { type: 'warning' })
          .then(async () => {
            await this.doDeleteAllByPaging(this.deleteRule);
          })
          .catch(() => {});
        return;
      }
      if (!this.validateDeleteSelections()) return;
      this.$confirm('确认删除选中的重复商品？此操作不可撤销。', '提示', { type: 'warning' })
        .then(async () => {
          await this.doDelete();
        })
        .catch(() => {});
    },
    /**
     * 全部页选择：分页获取所有数据，按保留规则筛选后执行删除
     * - 仅在 deleteSelectScope === 'all' 时使用
     *
     * @param {string} rule 保留规则：'earliest' | 'latest' | 'platformMost'
     */
    async doDeleteAllByPaging(rule) {
      const qp = this.queryParams || {};
      const PAGE_SIZE = 50; // 每页获取 50 条数据

      // 调试数据
      const debugData = [];
      const allGroups = [];

      // 重置进度统计
      const resetProgress = () => {
        this.deleteProgress.total = 0;
        this.deleteProgress.done = 0;
        this.deleteProgress.success = 0;
        this.deleteProgress.fail = 0;
        this.deleteProgress.failedTasks = [];
        this.deleteProgress.retry.total = 0;
        this.deleteProgress.retry.done = 0;
        this.deleteProgress.retry.success = 0;
        this.deleteProgress.retry.fail = 0;
        this.deleteProgress.retry.running = false;
      };

      resetProgress();
      this.deleteProgress.visible = true;
      this.deleteProgress.running = true;
      this.deleteProgress.fetchStatus = 'fetching'; // 正在获取数据
      this.deleteProgress.fetchCurrent = 0; // 当前已获取条数
      this.deleteProgress.fetchTotal = 0; // 总条数
      this.loading = true;

      try {
        // 步骤 1: 分页获取所有数据
        let pageNo = 1;
        let hasMore = true;

        while (hasMore) {
          const data = await getDuplicateGroupList({
            pageNo,
            pageSize: PAGE_SIZE,
            startTime: qp.startTime,
            endTime: qp.endTime
          });
          const groups = Array.isArray(data && data.records) ? data.records : [];
          const total = Number(data && data.total) || 0;

          allGroups.push(...groups);
          this.deleteProgress.fetchTotal = total;
          this.deleteProgress.fetchCurrent = allGroups.length;

          // 判断是否还有更多数据
          if (allGroups.length >= total || groups.length < PAGE_SIZE) {
            hasMore = false;
          }
          pageNo++;
        }

        console.log('===== 删除数据调试信息 =====');
        console.log('保留规则:', rule);
        console.log('获取到的总组数:', allGroups.length);

        // 获取数据完成，清除获取状态
        this.deleteProgress.fetchStatus = '';

        // 设置总组数用于进度显示
        this.allGroupsLength = allGroups.length;

        // 步骤 2: 应用保留规则，计算每组要删除的 baseItemIds
        const toDeleteBaseItemIds = [];
        this.deleteProgress.processStatus = 'processing'; // 正在处理数据
        this.deleteProgress.processCurrent = 0;

        for (let i = 0; i < allGroups.length; i++) {
          const rec = allGroups[i];
          const details = Array.isArray(rec.itemDetails) ? rec.itemDetails : [];

          this.deleteProgress.processCurrent = i + 1;

          // 构建与 UI 一致的数据结构（复用 fetchGroups 中的转换逻辑）
          const items = details.map(it => {
            // 处理平台数据
            let platformCodes = [];
            const cps = it.canPublishPlatforms;
            if (Array.isArray(cps)) {
              cps.forEach(p => {
                if (typeof p === 'string') {
                  try {
                    const parsed = JSON.parse(p);
                    if (Array.isArray(parsed)) {
                      parsed.forEach(code => { if (typeof code === 'string') platformCodes.push(code); });
                    } else {
                      platformCodes.push(p);
                    }
                  } catch (e) {
                    platformCodes.push(p);
                  }
                } else if (Array.isArray(p)) {
                  p.forEach(code => { if (typeof code === 'string') platformCodes.push(code); });
                }
              });
            }
            platformCodes = Array.from(new Set(platformCodes.filter(Boolean)));

            return {
              mainImage: it.mainImage || '',
              title: it.title || '',
              outerId: it.outerId || '',
              completedPlatforms: platformCodes,
              source: it.itemSource || '',
              baseItemId: it.baseItemId || '',
              creatorTime: `${it.createByName || '无'}${it.createTime ? (' / ' + it.createTime) : ''}`.trim()
            };
          });

          // 复用现有的 computeKeepRows 方法计算保留项
          const keepRows = this.computeKeepRows({ items }, rule);
          const keepIds = new Set(keepRows.map(r => String(r.baseItemId)));

          // 收集要删除的 baseItemIds（排除保留项）
          const toDeleteIds = items
            .map(r => String(r.baseItemId))
            .filter(id => id && !keepIds.has(id));

          // 调试数据：记录每组的完整信息
          debugData.push({
            repeatId: rec.repeatId || rec.id,
            duplicateCodes: details.map(d => d.outerId || '').join(', '),
            allItems: items,
            keepRows: keepRows,
            keepIds: Array.from(keepIds),
            toDeleteIds: toDeleteIds
          });

          // 只有当有要删除的 ID 时才收集
          if (toDeleteIds.length > 0) {
            toDeleteBaseItemIds.push(...toDeleteIds);
          }
        }

        // 数据处理完成，清除处理状态
        this.deleteProgress.processStatus = '';

        // 保存待删除的 baseItemIds
        this.toDeleteBaseItemIds = toDeleteBaseItemIds;

        // 进入等待确认状态
        this.deleteProgress.waitingConfirm = true;
        this.deleteProgress.running = false;
        this.loading = false;

        // 调试输出：打印所有数据供用户验证
        console.log('每组详细数据:', debugData);
        console.log('最终要删除的 baseItemIds:', toDeleteBaseItemIds);
        console.log('========================');
      } catch (e) {
        console.error('删除执行异常:', e);
        this.$message && this.$message.error('删除执行异常');
        this.loading = false;
        this.deleteProgress.running = false;
        this.deleteProgress.fetchStatus = '';
        this.deleteProgress.processStatus = '';
      }
    },
    /**
     * 确认删除：执行实际的删除操作
     */
    async confirmDelete() {
      const toDeleteBaseItemIds = this.toDeleteBaseItemIds || [];
      const BATCH_SIZE = 10;

      if (!toDeleteBaseItemIds.length) {
        this.$message && this.$message.info('没有需要删除的数据');
        this.closeDeleteProgressDialog();
        return;
      }

      // 开始删除
      this.deleteProgress.waitingConfirm = false;
      this.deleteProgress.running = true;
      this.deleteProgress.status = 'deleting';
      this.deleteProgress.total = toDeleteBaseItemIds.length;

      try {
        // 分批次删除（每批 10 条）
        for (let i = 0; i < toDeleteBaseItemIds.length; i += BATCH_SIZE) {
          const batch = toDeleteBaseItemIds.slice(i, i + BATCH_SIZE);
          try {
            const ok = await deleteRepeatItems(batch);
            if (ok) {
              this.deleteProgress.success += batch.length;
            } else {
              this.deleteProgress.fail += batch.length;
              this.deleteProgress.failedTasks.push(...batch);
            }
            this.deleteProgress.done += batch.length;
          } catch (e) {
            console.error('批量删除失败:', e);
            this.deleteProgress.fail += batch.length;
            this.deleteProgress.done += batch.length;
            this.deleteProgress.failedTasks.push(...batch);
          }

          // 每批次强制更新一次视图
          this.$forceUpdate();
        }

        // 删除完成，清除状态
        this.deleteProgress.status = '';
        this.deleteProgress.running = false;

        // 完成
        this.pagination.pageNo = 1;
        await this.fetchGroups();
        // 更新平台额度数据
        this.$store.dispatch('fetchPlatformQuota', { force: true });
        this.selections = {};
        this.deleteRule = '';
        this.toDeleteBaseItemIds = [];

        if (this.deleteProgress.fail > 0) {
          this.$message && this.$message.warning(`删除执行完成：成功 ${this.deleteProgress.success} 个，失败 ${this.deleteProgress.fail} 个`);
        } else {
          this.$message && this.$message.success(`删除执行完成：成功 ${this.deleteProgress.success} 个`);
        }
      } catch (e) {
        console.error('删除执行异常:', e);
        this.$message && this.$message.error('删除执行异常');
        this.deleteProgress.running = false;
      }
    },
    /**
     * 取消删除：关闭确认对话框
     */
    cancelDelete() {
      this.toDeleteBaseItemIds = [];
      this.deleteProgress.waitingConfirm = false;
      this.deleteProgress.visible = false;
      this.deleteProgress.running = false;
      this.loading = false;
    },
    /**
     * 失败重试：对 doDeleteAllByPaging 过程中记录的失败参数再次执行删除
     * - 仅在进度弹窗结束后可点击
     * - 重试成功：从失败列表中移除，并同步更新主统计（success++ / fail--）
     */
    async retryDeleteFailed() {
      const tasks = Array.isArray(this.deleteProgress.failedTasks) ? this.deleteProgress.failedTasks.slice() : [];
      if (!tasks.length) return;
      if (this.deleteProgress.running || this.deleteProgress.retry.running) return;

      this.deleteProgress.retry.total = tasks.length;
      this.deleteProgress.retry.done = 0;
      this.deleteProgress.retry.success = 0;
      this.deleteProgress.retry.fail = 0;
      this.deleteProgress.retry.running = true;
      this.loading = true;
      try {
        const concurrency = Math.max(1, Math.min(20, tasks.length));
        let idx = 0;
        const keepFailed = [];
        const workers = new Array(concurrency).fill(0).map(async () => {
          while (idx < tasks.length) {
            const cur = tasks[idx];
            idx += 1;
            const repeatId = cur && cur.repeatId ? String(cur.repeatId) : '';
            const baseItemIds = Array.isArray(cur && cur.baseItemIds) ? cur.baseItemIds.map(id => String(id)) : [];
            if (!baseItemIds.length) {
              this.deleteProgress.retry.done += 1;
              this.deleteProgress.retry.success += 1;
              continue;
            }
            try {
              const ok = await deleteRepeatItems(baseItemIds);
              if (ok) {
                this.deleteProgress.retry.success += 1;
                this.deleteProgress.success += 1;
                if (this.deleteProgress.fail > 0) this.deleteProgress.fail -= 1;
              } else {
                this.deleteProgress.retry.fail += 1;
                keepFailed.push({ repeatId, baseItemIds });
              }
            } catch (e) {
              this.deleteProgress.retry.fail += 1;
              keepFailed.push({ repeatId, baseItemIds });
            } finally {
              this.deleteProgress.retry.done += 1;
            }
          }
        });
        await Promise.all(workers);
        this.deleteProgress.failedTasks = keepFailed;
        this.pagination.pageNo = 1;
        await this.fetchGroups();
        // 更新平台额度数据
        this.$store.dispatch('fetchPlatformQuota', { force: true });
        this.selections = {};
        this.deleteRule = '';
        if (this.deleteProgress.failedTasks.length > 0) {
          this.$message && this.$message.warning(`重试完成：成功 ${this.deleteProgress.retry.success} 组，失败 ${this.deleteProgress.retry.fail} 组`);
        } else {
          this.$message && this.$message.success(`重试完成：成功 ${this.deleteProgress.retry.success} 组`);
        }
      } catch (e) {
        this.$message && this.$message.error('重试执行异常');
      } finally {
        this.loading = false;
        this.deleteProgress.retry.running = false;
      }
    },
    // TODO: 新增 全局快捷删除：应用到当前页或全部页所有分组
    applyQuickDeleteAll(rule) {
      if (!rule) return; // 表单防御：未选择规则不执行
      this.$nextTick(() => {
        const targetGroups = (this.deleteSelectScope === 'all' ? (this.displayGroups || []) : (this.pagedGroups || []));
        targetGroups.forEach(group => {
          const ref = this.$refs['deleteTable-' + group.id];
          const tables = Array.isArray(ref) ? ref : (ref ? [ref] : []);
          const keepRows = this.computeKeepRows(group, rule || 'earliest');
          const keepKeySet = new Set((keepRows || []).map(r => this.getRowKey(r)));
          const toSelect = (group.items || []).filter(r => !keepKeySet.has(this.getRowKey(r)));
          tables.forEach(t => {
            try {
              if (typeof t.clearSelection === 'function') t.clearSelection();
              if (typeof t.toggleRowSelection === 'function') {
                toSelect.forEach(r => t.toggleRowSelection(r, true));
              } else if (typeof t.toggleAllSelection === 'function') {
                t.toggleAllSelection();
                if (typeof t.toggleRowSelection === 'function') {
                  (keepRows || []).forEach(r => t.toggleRowSelection(r, false));
                }
              }
            } catch (e) {}
          });
          this.$set(this.selections, group.id, toSelect);
        });
      });
    },
    // TODO: 新增 全局重置：根据选择范围重置所有分组的选择
    resetDeleteSelectionAll() {
      this.$nextTick(() => {
        const targetGroups = (this.deleteSelectScope === 'all' ? (this.displayGroups || []) : (this.pagedGroups || []));
        targetGroups.forEach(group => {
          const ref = this.$refs['deleteTable-' + group.id];
          const tables = Array.isArray(ref) ? ref : (ref ? [ref] : []);
          tables.forEach(t => {
            try { if (typeof t.clearSelection === 'function') t.clearSelection(); } catch (e) {}
          });
          this.$set(this.selections, group.id, []);
        });
      });
    },
    /**
     * 删除Tab：范围选择变化
     * - “全部页选择”不触发额外查询，仍按分页查询
     * - 当范围为“全部页选择”时：当前页立即按保留规则（如已选择）自动勾选；翻页时也会自动勾选
     *
     * @param {string} val 选择范围：'page' | 'all'
     */
    onDeleteSelectScopeChange(val) {
      if (val === 'all') {
        if (this.deleteRule) {
          this.applyQuickDeleteAll(this.deleteRule);
        } else {
          this.$nextTick(() => this.syncDeleteSelectionOnPage());
        }
      }
    },
    // TODO: 新增 删除Tab：保留规则选择变化
    onDeleteRuleChange(val) {
      // 直接按当前范围应用规则
      this.applyQuickDeleteAll(val);
    },
    // TODO: 新增 删除Tab：重置选择（清空单选框与所有分组选择）
    onResetDeleteAll() {
      this.deleteRule = '';
      this.resetDeleteSelectionAll();
    },
    // TODO: 新增 删除Tab：同步当前页表格的勾选呈现（根据 selections）
    syncDeleteSelectionOnPage() {
      this.$nextTick(() => {
        (this.pagedGroups || []).forEach(group => {
          const selected = this.selections[group.id] || [];
          const ref = this.$refs['deleteTable-' + group.id];
          const tables = Array.isArray(ref) ? ref : (ref ? [ref] : []);
          tables.forEach(t => {
            try {
              if (typeof t.clearSelection === 'function') t.clearSelection();
              if (typeof t.toggleRowSelection === 'function') {
                selected.forEach(r => t.toggleRowSelection(r, true));
              }
            } catch (e) {}
          });
        });
      });
    },
    // 解析创建时间为时间戳，兼容 "创建人 / 时间" 格式
    getRowTimestamp(row) {
      const raw = (row && row.creatorTime) ? String(row.creatorTime) : '';
      // 取分隔符后面的时间部分
      const parts = raw.split('/');
      const timeStr = (parts.length > 1 ? parts[parts.length - 1] : raw).trim();
      if (!timeStr) return 0;
      // 替换为兼容的日期格式
      const normalized = timeStr.replace(/-/g, '/');
      const ts = Date.parse(normalized);
      return isNaN(ts) ? 0 : ts;
    },
    computeKeepRowsByPlatformMost(rows) {
      const list = Array.isArray(rows) ? rows : [];
      if (!list.length) return [];
      let bestCount = -1;
      let bestRows = [];
      list.forEach(r => {
        const platforms = r ? r.completedPlatforms : null;
        const cnt = Array.isArray(platforms) ? platforms.length : 0;
        if (cnt > bestCount) {
          bestCount = cnt;
          bestRows = [r];
        } else if (cnt === bestCount) {
          bestRows.push(r);
        }
      });
      return bestRows;
    },
    computeKeepRowByTime(rows, rule) {
      const list = Array.isArray(rows) ? rows : [];
      if (!list.length) return null;
      const getStableKey = (row) => String((row && row.baseItemId) || this.getRowKey(row) || '');
      const compareStableKey = (a, b) => getStableKey(a).localeCompare(getStableKey(b), 'zh-Hans-CN', { numeric: true });
      if (rule === 'latest') {
        let best = null;
        let bestTs = -1;
        let hasValid = false;
        list.forEach(r => {
          const ts = this.getRowTimestamp(r);
          const valid = ts > 0;
          if (!valid) return;
          if (!hasValid || ts > bestTs || (ts === bestTs && compareStableKey(r, best) > 0)) {
            best = r;
            bestTs = ts;
            hasValid = true;
          }
        });
        if (hasValid) return best;
        return list.slice().sort(compareStableKey).slice(-1)[0];
      }
      // 默认 earliest
      let best = null;
      let bestTs = -1;
      let hasValid = false;
      list.forEach(r => {
        const ts = this.getRowTimestamp(r);
        const valid = ts > 0;
        if (!valid) return;
        if (!hasValid || ts < bestTs || (ts === bestTs && compareStableKey(r, best) < 0)) {
          best = r;
          bestTs = ts;
          hasValid = true;
        }
      });
      if (hasValid) return best;
      return list.slice().sort(compareStableKey)[0];
    },
    computeKeepRows(group, rule) {
      const rows = (group && group.items) ? group.items : [];
      if (rule === 'platformMost') return this.computeKeepRowsByPlatformMost(rows);
      const keep = this.computeKeepRowByTime(rows, rule);
      return keep ? [keep] : [];
    },
    /**
     * 应用快捷删除（单个分组）：按保留规则自动勾选“需要删除”的商品行
     * - earliest/latest：仅保留 1 条，其余全部勾选
     * - platformMost：可能存在并列最大值，允许保留多条，其余全部勾选
     *
     * @param {Object} group 重复分组对象（包含 items）
     * @param {string} rule 保留规则：'earliest' | 'latest' | 'platformMost'
     */
    applyQuickDelete(group, rule) {
      this.$nextTick(() => {
        // 由于表格在展开/分页/数据刷新后可能重新渲染，等 DOM/组件更新完成再操作 selection
        const ref = this.$refs['deleteTable-' + group.id];
        // Vue2 + v-for + ref 的组合场景下，$refs 可能是数组或单实例；这里统一为数组处理
        const tables = Array.isArray(ref) ? ref : (ref ? [ref] : []);
        if (!tables.length) return;
        // 计算“保留项”集合（注意 platformMost 可能返回多条保留项）
        const keepRows = this.computeKeepRows(group, rule || 'earliest');
        // 用 rowKey 做集合判断，避免对象引用变化导致的 r !== keep 失效问题
        const keepKeySet = new Set((keepRows || []).map(r => this.getRowKey(r)));
        // 需要勾选的行 = 分组所有行 - 保留项
        // 勾选含义：这些行将作为“待删除”的商品
        const toSelect = (group.items || []).filter(r => !keepKeySet.has(this.getRowKey(r)));
        tables.forEach(t => {
          try {
            // 先清空当前表格勾选，再按规则勾选目标行，保证每次应用规则都可重复且结果稳定
            if (typeof t.clearSelection === 'function') t.clearSelection();
            if (typeof t.toggleRowSelection === 'function') {
              // Element-UI Table 推荐方式：逐行勾选
              toSelect.forEach(r => t.toggleRowSelection(r, true));
            } else if (typeof t.toggleAllSelection === 'function') {
              // 兼容旧版本/不同实现：先全选，再取消保留项
              t.toggleAllSelection();
              if (typeof t.toggleRowSelection === 'function') {
                // 保留项可能是多条，需要逐条取消勾选
                (keepRows || []).forEach(r => t.toggleRowSelection(r, false));
              }
            }
          } catch (e) { /* noop */ }
        });
        // 同步到数据层：后续提交删除时从 selections 里汇总 baseItemId
        this.$set(this.selections, group.id, toSelect);
      });
    },
    // 重置选择（清空本组选择）
    resetDeleteSelection(group) {
      this.$nextTick(() => {
        const ref = this.$refs['deleteTable-' + group.id];
        const tables = Array.isArray(ref) ? ref : (ref ? [ref] : []);
        tables.forEach(t => {
          try { if (typeof t.clearSelection === 'function') t.clearSelection(); } catch (e) {}
        });
        this.$set(this.selections, group.id, []);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.duplicate-clean-drawer {
  /* TODO: 新增 抽屉头部样式统一为 EditDialog.vue 风格：字号、粗细与颜色，并移除默认下边距 */
  ::v-deep .el-drawer__header {
    margin-bottom: 0px;
    font-size: 18px;
    font-weight: 700;
    color: #3e4144;
  }

  ::v-deep .el-drawer__body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .drawer-body {
    padding: 10px 20px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: visible;
  }

  ::v-deep .el-tabs {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
  }

  ::v-deep .el-tabs__content {
    flex: 1;
    overflow: visible;
    min-height: 0;
  }

  ::v-deep .el-tab-pane {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: visible;
  }

  /* 第一个 Tab（合并商品）内的元素 */
  ::v-deep .el-tab-pane:first-child {
    .tips, .toolbar, .el-table {
      flex-shrink: 0;
    }
    .list-with-pagination {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }

  /* 第二个 Tab（删除商品）内的元素 */
  ::v-deep .el-tab-pane:last-child {
    .toolbar, .quick-delete-bar, .el-table {
      flex-shrink: 0;
    }
    .list-with-pagination {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }
}

.quick-delete-bar {
  padding: 6px 12px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
  color: #666;
}

.list-with-pagination {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* 使用 flex 布局让 pagination 固定在底部 */

  .group-list-scroll {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
    min-height: 0;

    /* 滚动条样式优化 */
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #c0c4cc;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-track {
      background-color: #f5f7fa;
    }
  }

  .pagination {
    flex-shrink: 0;
    margin: 8px 0 0;
    text-align: right;
    padding-top: 8px;
    background: #fff;
    border-top: 1px solid #f0f0f0;
  }
}
.toolbar { margin: 10px 0; }
.group-block { border: 1px solid #eee; margin-bottom: 14px; }
.group-header { background: #fafafa; padding: 8px 12px; color: #666; font-size: 13px; }
.group-header .divider { margin: 0 8px; color: #ddd; }
.group-header { display: flex; align-items: center; }
.group-header .spacer { flex: 1; }
.mgr8 { margin-right: 8px; }
.merge-confirm-text { line-height: 1.8; color: #666; }
.merge-progress-wrap { padding: 10px 6px; }
.merge-progress-row { line-height: 1.8; color: #666; }
.merge-progress-label { color: #333; font-weight: 600; }
.merge-progress-split { margin: 0 8px; color: #ddd; }
.img-icon {
  width: 24px;
  height: 24px;
}
// 获取数据进度
.fetching-progress {
  margin-bottom: 10px;
}
// 处理数据进度
.processing-progress {
  margin-bottom: 10px;
}
// 删除进度
.deleting-progress {
  margin-bottom: 10px;
}
// 等待确认
.waiting-confirm {
  padding: 20px 10px;
  text-align: center;

  .confirm-info {
    margin: 16px 0;
    font-size: 16px;
    color: #f56c6c;

    strong {
      font-size: 20px;
      margin: 0 4px;
    }
  }

  .confirm-tips {
    margin-top: 16px;
  }
}
</style>
